import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError, shareReplay, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { buildUrl } from "../shared/url.utils";

/** API response type for line numbers */
export interface LineNumberResponse {
  name: string;
}

/** Service to handle linenumber API */
@Injectable({
  providedIn: "root",
})
export class LineService {
  private lineNumbers: LineNumberResponse[] = [];
  private linesRequest$: Observable<LineNumberResponse[]> | null = null;

  private readonly apiSegment = "LineNumber";
  private readonly getStationsConnectedToLinesSegment =
    "GetStationsConnectedToLines";
  private readonly getSegment = "Get";

  private readonly headers = { "Api-Version": environment.linenumberApi.version };

  constructor(
    private httpClient: HttpClient
  ) {}

  public getLines(): Observable<LineNumberResponse[]> {
    if (this.lineNumbers.length > 0) {
      return of(this.lineNumbers);
    }

    if (!this.linesRequest$) {
      this.linesRequest$ = this.httpClient
        .get<LineNumberResponse[]>(
          buildUrl([
            environment.linenumberApi.path,
            this.apiSegment,
            this.getSegment,
          ]),
          { headers: this.headers }
        )
        .pipe(
          tap((lines) => {
            this.lineNumbers = lines ?? [];
          }),
          catchError((error: unknown) => {
            this.linesRequest$ = null;
            return throwError(() => error);
          }),
          shareReplay(1)
        );
    }

    return this.linesRequest$;
  }

  public setLineNumbers(lineNumbers: LineNumberResponse[]) {
    this.lineNumbers = lineNumbers ?? [];
  }

  /** Uses line data to get stations for each line  */
  public getStationsConnectedToLines() {
    return this.httpClient.get<{ [line: string]: string[] }>(
      buildUrl([
        environment.linenumberApi.path,
        this.apiSegment,
        this.getStationsConnectedToLinesSegment,
      ]),
      { headers: this.headers, }
    );
  }

  ngOnDestroy() {}
}
